module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-02.e94ce5ed.svg";